<template>
  <div>
    <template v-if="!this.$store.state.tenant.subdomain || this.$store.state.tenant.subdomain === '#pfx'">
      <FrontPagePfxBanner browsing />
      <div style="padding-top: 1rem;" />
    </template>
    <template v-else>
      <FrontPageTenantBanner />
    </template>

    <div class="container">

      <div class="filters" v-if="false"><!-- TODO disabled for now, to be implemented later -->
        <li>Building type <v-icon>expand_more</v-icon></li>
        <li>Size <v-icon>expand_more</v-icon></li>
        <li>Price <v-icon>expand_more</v-icon></li>
        <li>More filters <v-icon>expand_more</v-icon></li>
      </div>

      <h2>All properties</h2>

      <div class="status-filter">
        <li :class="{ active: filters.status === '' }" @click="filters.status = ''">All</li>
        <li :class="{ active: filters.status === 'upcoming' }" @click="filters.status = 'upcoming'">Upcoming</li>
        <li :class="{ active: filters.status === 'inprogress' }" @click="filters.status = 'inprogress'">In progress</li>
        <li :class="{ active: filters.status === 'closed' }" @click="filters.status = 'closed'">Closed</li>
      </div>

      <div class="clearfix" v-if="!loading">
        <div class="listing-item-container" v-for="auction in filteredAuctions" :key="auction.id" >
          <ListingItem :auction="auction" />
        </div>
        <div style="padding: 1rem 0;" v-if="filteredAuctions.length === 0">No properties found matching the criteria.</div>
      </div>

    </div>

  </div>
</template>

<script>
  import { mapMutations } from 'vuex'
  import FrontPagePfxBanner from './FrontPagePfxBanner.vue'
  import FrontPageTenantBanner from './FrontPageTenantBanner.vue'
  import ListingItem from './ListingItem.vue'
  import { auctionStatuses, auctionStatusIndex } from '../utils/PfxUtils.js'

  export default {
    components: {
      FrontPagePfxBanner,
      FrontPageTenantBanner,
      ListingItem
    },
    data() {
      return {
        auctionStatuses,
        auctions: [],
        filters: {
          status: ''
        }
      }
    },
    computed: {
      loading() {
        return this.$store.state.loadingSpinner
      },
      filteredAuctions() {
        if (this.filters.status !== '') {
          return this.auctions.filter(auction => {
            if (this.filters.status === 'upcoming') {
              return auction.status === this.auctionStatuses.OPEN.value || auction.status === this.auctionStatuses.FREEZE.value
            }
            if (this.filters.status === 'inprogress') {
              return auction.status === this.auctionStatuses.AUCTION.value
            }
            if (this.filters.status === 'closed') {
              return auction.status === this.auctionStatuses.PROCESSING.value || auction.status === this.auctionStatuses.IN_ESCROW.value || auction.status === this.auctionStatuses.CLOSED.value || auction.status === this.auctionStatuses.CANCELLED.value || auction.status === this.auctionStatuses.SOLD.value
            }
            return false
          })
        }
        return this.auctions
      }
    },
    created() {
      this.getAuctions()
    },
    mounted() {
      // subscribe to auction events
      this.$events.on('auction', update => {
        this.auctions
          .filter(auction => auction.id === update.id)
          .map(auction => Object.assign(auction, update))
      })
    },
    beforeDestroy() {
      this.$events.off('auction')
    },
    methods: {
      ...mapMutations(['setLoadingSpinner']),
      getAuctions() {
        let subdomain = this.$store.state.tenant.subdomain
        if (subdomain === '#pfx') { subdomain = '' } // no filtering when browsing listing of pfx site

        this.auctions = []
        const that = this
        that.setLoadingSpinner(true)
        this.$PfxBackendApi.getPublicAuctions(subdomain, null).then(res => {
          console.log('getPublicAuctions res', res)
          that.auctions = that.sortAuctions(res.data.data || [])
        }).catch(err => {
          console.error('getPublicAuctions err', err)
          this.$notify({ type: 'danger', message: 'Cannot fetch data about auctions'})
        }).then(() =>  that.setLoadingSpinner(false))
      },
      sortAuctions(auctions) {
        auctions.sort((a, b) => {
          const aa = auctionStatusIndex(a.status)
          const bb = auctionStatusIndex(b.status)
          return aa < bb ? -1 : aa === bb ? 0 : 1
        })
        return auctions
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../pfx.scss';

  .listing-item-container {
    @include stack();
    @include tablet-portrait-breakpoint {
      @include column(1/2, $cycle: 2);
    }
    @include tablet-landscape-breakpoint {
      @include column(1/3, $cycle: 3);
    }
    @include desktop-breakpoint {
      @include column(1/4, $cycle: 4);
    }
  }

  .filters {
    font-size: 0.85em;
    background-color: #ededed;
    padding: 1rem 2rem;
    margin-bottom: 1rem;

    li {
      display: inline-block;
      margin-right: 2rem;
    }
  }

  .status-filter {
    padding: 0.5rem 0;
    li {
      cursor: pointer;
      display: inline-block;
      margin-right: 2rem;
    }
    li.active {
      color: $color-pfx-brand;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Listings.vue